/* SP PDP — mejoras de ficha (diseño Soft):
   - Precio total (precio × cantidad) dentro del botón "Añadir al carrito".
   - Badge -X% recalculado por variante, en la fila del precio.
   - Referencia (SKU) sincronizada con la variante seleccionada.
   - Valor del atributo seleccionado junto a su etiqueta ("COLOR: Blue / White").
   - Icono carrito coherente con el header.
   Todo se RE-APLICA tras el re-render del selector nativo mediante MutationObserver. */
(function () {
  var root = document.querySelector('.product-details') || document;
  var scope = document.querySelector('.product-information, main, body') || document.body;
  var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];

  // Flechas de "Productos complementarios": scroll de la tira por el ancho de una card.
  if (!window.__spCompNavBound) {
    window.__spCompNavBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sp-comp-scroll]');
      if (!btn) return;
      var head = btn.closest('.sp-comp-head');
      var strip = head && head.parentElement.querySelector('[data-sp-comp-strip]');
      if (!strip) return;
      var dir = parseInt(btn.getAttribute('data-sp-comp-scroll'), 10);
      var card = strip.querySelector('.sp-pcard');
      var step = card ? card.getBoundingClientRect().width + 12 : 240;
      var max = strip.scrollWidth - strip.clientWidth;
      // al final + siguiente → vuelve al principio; al principio + anterior → va al final
      if (dir > 0 && strip.scrollLeft >= max - 2) strip.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dir < 0 && strip.scrollLeft <= 2) strip.scrollTo({ left: max, behavior: 'smooth' });
      else strip.scrollBy({ left: step * dir, behavior: 'smooth' });
    });
  }
  var VARIANTS = {}; // id -> { price, compare }

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; }
  function currentVariantId() { var i = root.querySelector('input[name="id"], select[name="id"]'); return i ? i.value : null; }
  function currentQty() { var q = root.querySelector('.quantity-input, input[name="quantity"], quantity-selector input'); var n = q ? parseInt(q.value, 10) : 1; return isNaN(n) || n < 1 ? 1 : n; }
  function curVar() { return VARIANTS[currentVariantId()]; }

  function priceContainer() {
    var c = root.querySelector('.price__sale');
    if (c && c.offsetParent !== null) return c;
    var vis = [].slice.call(root.querySelectorAll('.price')).filter(function (el) { return el.offsetParent !== null; })[0];
    return vis ? (vis.closest('.price__sale, .price__regular') || vis.parentElement) : null;
  }

  function updateAtcPrice() {
    var v = curVar(); if (!v) return;
    document.querySelectorAll('.add-to-cart-button').forEach(function (btn) {
      if (btn.closest('.sticky-add-to-cart')) return; // el sticky lleva su propio precio
      var txt = btn.querySelector('.add-to-cart-text') || btn;
      var span = txt.querySelector('.sp-atc-price');
      if (!span) { span = document.createElement('span'); span.className = 'sp-atc-price'; txt.appendChild(span); }
      span.textContent = money(v.price * currentQty());
    });
  }

  function updateDiscount() {
    var v = curVar(); var c = priceContainer(); if (!c) return;
    var badge = document.querySelector('.sp-pdp-discount');
    var onSale = v && v.compare && v.compare > v.price;
    if (!onSale) { if (badge) badge.hidden = true; return; }
    if (!badge) { badge = document.createElement('span'); badge.className = 'sp-pdp-discount'; }
    badge.hidden = false;
    badge.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
    if (badge.parentElement !== c) c.appendChild(badge);
  }

  function updateLegends() {
    root.querySelectorAll('.variant-option').forEach(function (fs) {
      var legend = fs.querySelector('legend'); if (!legend) return;
      var base = legend.getAttribute('data-sp-base');
      var lab = legend.querySelector('.sp-legend-label');
      if (!lab) {
        if (!base) { base = legend.textContent.trim(); legend.setAttribute('data-sp-base', base); }
        var keep = []; legend.querySelectorAll('.sp-sizeguide').forEach(function (g) { keep.push(g); });
        legend.textContent = '';
        lab = document.createElement('span'); lab.className = 'sp-legend-label'; legend.appendChild(lab);
        keep.forEach(function (g) { legend.appendChild(g); });
      }
      var checked = fs.querySelector('input:checked');
      var val = checked ? (checked.value || checked.getAttribute('aria-label') || '') : '';
      lab.innerHTML = base + (val ? ': <span class="sp-legend-val">' + val + '</span>' : '');
    });
  }

  var CART_SVG = '<svg class="sp-atc-cart" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 4h3l2.5 12h11L21 7H7"/><circle cx="10" cy="20" r="1.4" fill="currentColor"/><circle cx="18" cy="20" r="1.4" fill="currentColor"/></svg>';
  function injectCartIcon() {
    document.querySelectorAll('.add-to-cart-button').forEach(function (btn) {
      btn.querySelectorAll('.svg-wrapper, svg:not(.sp-atc-cart)').forEach(function (s) { if (!s.closest('.sp-atc-cart')) s.style.display = 'none'; });
      var txt = btn.querySelector('.add-to-cart-text') || btn;
      if (!txt.querySelector('.sp-atc-cart')) txt.insertAdjacentHTML('afterbegin', CART_SVG);
    });
  }

  // La referencia la pinta un bloque custom_liquid con la variante inicial (Liquid de servidor),
  // así que al cambiar de variante se quedaba con el SKU de la primera. El marcado ya traía el
  // engancho data-sp-ref; aquí se actualiza con el SKU de la variante seleccionada.
  function updateRef() {
    var el = document.querySelector('[data-sp-ref]'); if (!el) return;
    var strong = el.querySelector('strong'); if (!strong) return;
    var v = curVar();
    var sku = v && v.sku ? v.sku : '';
    strong.textContent = sku;
    el.hidden = !sku;
  }

  function updateStockChip() {
    var el = document.querySelector('[data-sp-stock]'); if (!el) return;
    var map = {};
    (el.getAttribute('data-map') || '').split(',').forEach(function (pr) { var i = pr.indexOf(':'); if (i > 0) map[pr.slice(0, i).trim()] = pr.slice(i + 1).trim(); });
    var st = map[currentVariantId()] || 'in';
    var sch = el.getAttribute('data-' + st + '-scheme') || '';
    var lbl = el.getAttribute('data-' + st + '-label') || '';
    el.className = 'sp-stockchip sp-stockchip--' + st + (sch ? ' color-' + sch : '');
    var t = el.querySelector('.sp-stockchip__txt'); if (t) t.textContent = lbl;
  }

  var SG_HTML = null; // el bloque vive dentro de .product-details, que el selector nativo reemplaza → cacheamos su HTML y lo re-inyectamos
  function placeSizeGuide() {
    var guide = document.querySelector('.sp-sizeguide');
    if (guide && !SG_HTML) SG_HTML = guide.outerHTML;
    if (!guide && SG_HTML) { var tmp = document.createElement('div'); tmp.innerHTML = SG_HTML; guide = tmp.firstElementChild; }
    if (!guide) return;
    var legends = (root || document).querySelectorAll('.variant-option legend');
    for (var i = 0; i < legends.length; i++) {
      var base = (legends[i].getAttribute('data-sp-base') || legends[i].textContent).toLowerCase();
      if (base.indexOf('talla') !== -1) { legends[i].classList.add('sp-has-guide'); if (guide.parentElement !== legends[i]) legends[i].appendChild(guide); break; }
    }
  }

  var mo = null;
  function syncAll() {
    if (mo) mo.disconnect();
    root = document.querySelector('.product-details') || root; // re-query: el nativo puede reemplazarlo
    updateAtcPrice(); updateDiscount(); updateRef(); updateLegends(); placeSizeGuide(); injectCartIcon(); updateStockChip();
    if (mo) mo.observe(scope, { childList: true, subtree: true });
  }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; syncAll(); }); }

  function init() {
    if (handle) {
      fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p) p.variants.forEach(function (v) { VARIANTS[v.id] = { price: v.price, compare: v.compare_at_price, sku: v.sku }; });
        syncAll();
      }).catch(syncAll);
    } else { syncAll(); }
    // Re-aplicar tras cualquier re-render del selector nativo (observando un ancestro estable).
    mo = new MutationObserver(schedule);
    mo.observe(scope, { childList: true, subtree: true });
    scope.addEventListener('change', schedule);
    scope.addEventListener('click', function () { setTimeout(schedule, 80); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
